export function validateScrapeChannelV116(type, baseURL, config = {}) {
  if (Number(type) !== 56) return;
  let url;
  try { url = new URL(baseURL); } catch { /* validated below */ }
  if (!url || !['http:', 'https:'].includes(url.protocol) || url.username || url.password || url.search || url.hash) {
    throw new Error('channel.edit.scrape_v116.endpoint_invalid');
  }
  if (config.edge_proxy || config.upstream_proxy || config.tailscale_server ||
    (config.egress_mode && config.egress_mode !== 'direct') || config.outbound_client_profile_v95 ||
    config.model_sync_v103 || config.video_protocol_v1016 || config.openrouter_v1015 || config.search_engines_v116?.length) {
    throw new Error('channel.edit.scrape_v116.transport_invalid');
  }
}
